import { ResponseErrorHandling } from "../../../../helper";
import commonService from "../../../../services/Common/service";
import FormDataService from "../../../../services/FormDataService";
import { CommonActionTypes } from "../../../action-types";

export const getClientFiles = (type) => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const res = await commonService.get(
      `/lookups/client/files-config?type=${type}`
    );
    return res.data;
  } catch (err) {
    const message = err.response.data.message || err.message || err.toString();

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};

export const uploadClientFiles = (data) => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const res = await FormDataService.post("/user/register/upload-files", data);
    return { success: true, data: res.data };
  } catch (err) {
    // Safely extract response data
    const status = err?.response?.status;
    const responseData = err?.response?.data;
    let message = "Something went wrong. Please try again.";

    if (status === 413) {
      message = "The total size of your upload`s exceeds the allowed limit. Please reduce file sizes.";
    } else if (responseData?.message) {
      message = responseData.message;
    } else if (err.message) {
      message = err.message;
    }

    // Handle general error response if available
    if (err?.response) {
      ResponseErrorHandling(err.response, dispatch);
    }

    // Dispatch rejection
    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });

    // Always return a consistent object so frontend never crashes
    return { success: false, error: message };
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};
